<template>
  <one-column-layout :loading="false">

    <title-bar :title="title" slot="titleBar">
      <div class="smd-spacer"/>

      <smd-btn icon="smd-icon-action-close" @click="close"/>
    </title-bar>

    <two-column-layout class="sb-min-180 hide-sidebar">
      <title-bar class="space-s-l" type="page" slot="sidebar">
        <smd-btn clean class="icon-text" @click="close">
          <i class="smd-icon-arrow-left"/>
          <label dark-normal>Back</label>
        </smd-btn>
      </title-bar>


      <div slot="content">

        <one-column-layout class="space-m">
          <title-bar title="" type="page" slot="titleBar">
            <div class="smd-spacer"/>
          </title-bar>

          <div class="form">
            <cases-list :packagedCases="packagedCases" />
          </div>
        </one-column-layout>

      </div>

    </two-column-layout>

  </one-column-layout>
</template>

<script>
  import CasesList from '../../submissions/cases/pogs-submissions__cases--packaged'
  import uiHelper from '../../../../mixins/uihelper'

  import Routes from '../../../../router/route-constants'

  import {mapGetters} from 'vuex'
  import {
    ACTION_LOAD_PACKAGED_CASES,
    GETTER_PACKAGED_CASES
  } from '../../../../store/modules/submissions'

  export default {
    mixins: [uiHelper],
    components:{
      CasesList
    },
    data(){
      return{
        title  : 'Create Submission'
      }
    },
    computed: {
      ...mapGetters({
        packagedCases : GETTER_PACKAGED_CASES
      })
    },
    methods:{
      close(){
        this.toggleOverlay(false);
        this.$router.push({name: Routes.ROUTE_SUBMISSION_CENSUS})
      }
    },
    mounted(){
      const submissionid = this.$route.params.submissionid;
      this.$store.dispatch(ACTION_LOAD_PACKAGED_CASES, submissionid);
      if(!this.showOverlay){this.toggleOverlay();}
    }
  }
</script>

<style lang="scss">

  @import "../../../../scaffolding/scss/pogs-util";

  .form.new-patient{
    @include make-grid-cols(150px 1fr, space(m));

    & > div:first-child{
      @extend %flex-col, %align-items-center;
    }

    .form__row--x{
      max-width: 80%;
    }
  }

  .page__content {
    @include responsive(mobile) {
      padding: 0 !important;
      font-size: 12px;
    }
  }

</style>
